import { createAction, props } from '@ngrx/store';

export const set = createAction('[Country] set', props<{ payload: string }>());
